import React from 'react';
import PropTypes from 'prop-types';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import metaOverrideSet from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/MetaOverrideSet';
import Content from './Content';

const ScenarioActivationAutomatedTransferScheduledStepTemplate = ({
  resource,
}) => {
  return (
    <WizardStepWrapperTemplate
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={Content}
      LayoutProps={{
        resource,
      }}
    />
  );
};

ScenarioActivationAutomatedTransferScheduledStepTemplate.propTypes = {
  resource: PropTypes.object.isRequired,
};

export default ScenarioActivationAutomatedTransferScheduledStepTemplate;
